import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { DailyAlertDataType, EnvironmentRiskScoreChartDataType, ItemType, NotificationDataType, StackRankingDataType, substanceFrequencyDataType } from "../../components/dashboard/types"
import { getStackRankingDataThunk, getDashboardWidgetsSorting, getRecentNotificationData, getDailyAlertData, getEnvironmentRiskScoreData, getSubstanceFrequencyDataThunk } from "../thunk/mainDashboardThunk"
type InitialValueType = {
    widgetsSorting: (Omit<ItemType, 'Component'>)[];
    recentNotification: {
        loading: boolean;
        data: NotificationDataType[]
    };
    dailyAlert: {
        loading: boolean;
        data: DailyAlertDataType[];
    }
    environmentRiskScore: {
        loading: boolean;
        currentScore: number;
        prevScore: number;
        environmentRiskScoreChartData: EnvironmentRiskScoreChartDataType[]
    },
    stackRanking: {
        loading: boolean;
        data: StackRankingDataType[]
    },
    substanceFrequency: {
        loading: boolean;
        data: substanceFrequencyDataType[]
    }
}
const initialValue: InitialValueType = {
    widgetsSorting: [],
    recentNotification: {
        loading: true,
        data: []
    },
    dailyAlert: {
        loading: true,
        data: []
    },
    environmentRiskScore: {
        loading: true,
        currentScore: 0,
        prevScore: 0,
        environmentRiskScoreChartData: []
    },
    stackRanking: {
        loading: true,
        data: []
    },
    substanceFrequency: {
        loading: true,
        data: []
    }
}
const mainDashboard = createSlice({
    name: "mainDashboard",
    initialState: initialValue,
    reducers: {
        setEnvironmentRiskScoreChartData(state, action: PayloadAction<EnvironmentRiskScoreChartDataType[]>) {
            return {
                ...state,
                environmentRiskScore: {
                    ...state.environmentRiskScore,
                    environmentRiskScoreChartData: action?.payload || []
                }
            }
        },
        appendEnvironmentRiskScoreChartData(state, action: PayloadAction<EnvironmentRiskScoreChartDataType>) {
            return {
                ...state,
                environmentRiskScore: {
                    ...state.environmentRiskScore,
                    environmentRiskScoreChartData: [...state?.environmentRiskScore?.environmentRiskScoreChartData, action?.payload]
                }
            }
        },

        setMainDashboardInitialState(state) {
            return initialValue;
        },
        setMainDashboardLoaderFalse(state) {
            return {
                widgetsSorting: [],
                recentNotification: {
                    loading: false,
                    data: []
                },
                dailyAlert: {
                    loading: false,
                    data: []
                },
                environmentRiskScore: {
                    loading: false,
                    currentScore: 0,
                    prevScore: 0,
                    environmentRiskScoreChartData: []
                },
                stackRanking: {
                    loading: false,
                    data: []
                },
                substanceFrequency: {
                    loading: false,
                    data: []
                }
            }
        }

    },
    extraReducers(builder) {
        builder.addCase(getDashboardWidgetsSorting.fulfilled, (state, action) => {
            return {
                ...state,
                widgetsSorting: action?.payload || []
            }
        })

        builder.addCase(getRecentNotificationData.pending, (state, action) => {
            return {
                ...state,
                recentNotification: {
                    loading: true,
                    data: []
                }
            }
        })
        builder.addCase(getRecentNotificationData.fulfilled, (state, action) => {
            return {
                ...state,
                recentNotification: {
                    loading: false,
                    data: action?.payload || []
                }
            }
        })

        builder.addCase(getDailyAlertData.pending, (state) => {
            state.dailyAlert = {
                loading: true,
                data: []
            };
        })
        builder.addCase(getDailyAlertData.fulfilled, (state, action) => {
            state.dailyAlert = {
                loading: false,
                data: action?.payload || []
            }
        })
        builder.addCase(getEnvironmentRiskScoreData.pending, (state) => {
            return {
                ...state,
                environmentRiskScore: {
                    ...state.environmentRiskScore,
                    loading: true,
                    currentScore: 0,
                    prevScore: 0,
                }
            }
        })
        builder.addCase(getEnvironmentRiskScoreData.fulfilled, (state, action) => {
            return {
                ...state,
                environmentRiskScore: {
                    ...state.environmentRiskScore,
                    loading: false,
                    currentScore: action.payload?.currentScore,
                    prevScore: action?.payload?.prevScore,

                }
            }
        })
        builder.addCase(getStackRankingDataThunk.pending, (state) => {
            state.stackRanking = {
                loading: true,
                data: []
            };
        })
        builder.addCase(getStackRankingDataThunk.fulfilled, (state, action) => {
            state.stackRanking = {
                loading: false,
                data: action?.payload || []
            };
        })
        builder.addCase(getSubstanceFrequencyDataThunk.pending, (state) => {
            state.substanceFrequency = {
                loading: true,
                data: []
            };
        })
        builder.addCase(getSubstanceFrequencyDataThunk.fulfilled, (state, action) => {
            state.substanceFrequency = {
                loading: false,
                data: action?.payload || []
            };
        })
    },
});

export const { setMainDashboardLoaderFalse, setMainDashboardInitialState, setEnvironmentRiskScoreChartData, appendEnvironmentRiskScoreChartData } = mainDashboard.actions;

export default mainDashboard.reducer;